import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineEllipsisHIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 10a2 2 0 0 0-1.9616 2.3902 2.0004 2.0004 0 0 0 1.5714 1.5714A2 2 0 1 0 12 10Zm-7 0a1.9998 1.9998 0 0 0-1.8478 1.2346 2.0002 2.0002 0 0 0 1.4576 2.727A2.0003 2.0003 0 0 0 7 12a2 2 0 0 0-2-2Zm14 0a2 2 0 0 0-1.9616 2.3902 2.0004 2.0004 0 0 0 1.5714 1.5714A2 2 0 1 0 19 10Z"/>
  </SvgIcon>
}

export default LineEllipsisHIcon
